export const Helpers = (() => {
	'use strict';
	const currentLocation = window.location.pathname;

	let $body = $('body');

	function init() {
		links();
		mobile_menu();
		hideMenu();
		highlightMenuColor();
		headerMargin();
	}

	function links() {
		document.querySelectorAll('a').forEach((anchorTag) => {
			// External links
			if (
				anchorTag.href.indexOf(window.location.host) < 0 &&
				anchorTag.href.indexOf('mailto') < 0 &&
				anchorTag.href.indexOf('tel') < 0
			)
				anchorTag.setAttribute('target', '_blank');

			// Anchor links
			if (
				anchorTag.href.indexOf('#') === 0 &&
				!document.getElementById(anchorTag.href.replace('#', ''))
			)
				window.scrollTo({ top: 0, behavior: 'smooth' });
		});
	}

	function mobile_menu() {
		const mobileTrigger = document.querySelector('.site-header__mobile-trigger');

		if (!mobileTrigger) return;

		mobileTrigger.addEventListener('click', () => {
			mobileTrigger.classList.toggle('open');
			document.body.classList.toggle('mobile-nav-open');
		});
	}

	const highlightMenuColor = () => {
		var previousScroll = 0;
		const highliColor = $('.site-header').attr('data-highlight');

		let scroll = 0;

		if ($('.text-color--light').length) {
			$('body').addClass('text-color--light');
		}

		$(window).scroll(function (event) {
			scroll = $(this).scrollTop();

			let scrollTime = 20;
			let bottom;

			if ($('.case-study__info').length) {
				bottom = $('.case-study__info').height();
				let currentOffset = $('.case-study__info').offset();
				scrollTime = bottom + currentOffset.top;
			}

			if (scroll <= scrollTime) {
				if ($('.text-color--light').length) {
					$('body').addClass('text-color--light');
				}
			}

			if (scroll >= scrollTime) {
				if ($('.header-style--light').length != 1) {
					$('body').removeClass('text-color--light');
				}
			}

			previousScroll = scroll;
		});
	};

	function hideMenu() {
		var previousScroll = 0;
		let scrollInit = 0;

		$(window).scroll(function (event) {
			var scroll = $(this).scrollTop();
			if (scroll == 0) {
				$body.removeClass('scrolledPage');
			} else {
				$body.addClass('scrolledPage');
			}

			if (scroll >= previousScroll) {
				$body.addClass('scrollDown').removeClass('scrollUp');
			} else {
				$body.addClass('scrollUp').removeClass('scrollDown');
			}
			previousScroll = scroll;
		});
	}

	function headerMargin() {
		if($('body:not(.home)').length){
			var $height = $('.site-header').innerHeight();
			var main = $('#pxMainContent');
	
			main.css('padding-top', $height);
			// main.css('margin-top', -$height);
		}
		
	}

	return {
		init: init,
	};
})();
